<template>
  <div class="container">
    <vs-breadcrumb
        :items="[
        { title: 'Tesorería', url: '/treasury' },
        { title: 'Comisiones Recurrentes', active: true }
      ]"></vs-breadcrumb>

    <recurrent-commission-finder
        v-if="startDate !== null"
        class="mt-4"
        :start-date="startDate"
        :end-date="endDate"
        @onChangeDate="dateFilterChangedHandler"
    />

    <recurrent-commission-results
      @onSuccess="onSuccessHandler"
      ref="recurrentCommissionResult"
      mode="applicant" />
  </div>
</template>

<script>
import RecurrentCommissionFinder from "@components/recurrent-commission/recurrent-commission-finder";
import moment from "moment";
import RecurrentCommissionResults from "@components/recurrent-commission/recurrent-commission-results";

export default {
  name: "applicant-recurrent-commission",
  components: {RecurrentCommissionResults, RecurrentCommissionFinder},
  data: () => ({
    startDate: null,
    endDate: null
  }),
  async mounted() {
    let startDate = moment().endOf('month')
    this.endDate = startDate.format("YYYY-MM-DD");
    this.startDate = startDate
        .clone()
        .subtract(1, 'months')
        .add(1, 'day')
        .format("YYYY-MM-DD")

    await this.$refs.recurrentCommissionResult.fetchCommission(this.startDate, this.endDate);
  },
  methods: {
    async dateFilterChangedHandler(ev) {
      this.startDate = ev.startDate;
      this.endDate = ev.endDate;

      await this.$refs.recurrentCommissionResult.fetchCommission(this.startDate, this.endDate);
    },
    onSuccessHandler(ev) {}
  },
}
</script>
